const languages = [
  { name: 'ES', code: 'es' },
  { name: 'EN', code: 'en' }
]

export default languages
